import { useEffect, useState } from "react";

export const useOnceWhen = (check: boolean, fn: VoidFunction, cleanup: VoidFunction) => {
  const [used, setUsed] = useState(false);

  useEffect(() => {
    if (check && !used) {
      setUsed(true);
      fn();
    }
    if (check && used) {
      return () => cleanup();
    }
  }, [check, used]);
};
